import { render, staticRenderFns } from "./faturaislem.vue?vue&type=template&id=dadc8b08"
import script from "./faturaislem.vue?vue&type=script&lang=js"
export * from "./faturaislem.vue?vue&type=script&lang=js"
import style0 from "./faturaislem.vue?vue&type=style&index=0&id=dadc8b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports